import React, { useContext, useCallback, useMemo, useState } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext,IntlContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesComponent from './../../CoveragesComponent/CoveragesComponent';
import ScheduleItemsComponent from './../../ScheduleItemsComponent/ScheduleItemsComponent';
import PolicyCoverageComponent from '../PolicyCoverageComponent/PolicyCoverageComponent';
import { EYDiscountSurchargeTable } from './../../PA/EYDiscountSurchargeTable/EYDiscountSurchargeTable';
import styles from './PolicyFarmInformationComponent.module.scss'
import metadata from './PolicyFarmInformationComponent.metadata.json5';
import messages from './PolicyFarmInformationComponent.messages';


const getHeaderSection = (title, title1) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.customAccordion_cardTitle} `}>{title}</h2>
            <h3 className={`${styles.customAccordion_cardTitle2} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
        </React.Fragment>
    );
};


const getFarmOutBuildingHeaderSection = (title) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.customAccordion_cardTitle}`}>{title}</h2>

        </React.Fragment>
    );
};

function PolicyFarmInformationComponent(props) {
    const { value: policyData } = props;
    const farmData = policyData.lobs.farm;
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const [fobCoverageOpenItems, SetFobCoverageOpenItems] = useState([]);
    const [farmCoverageOpenItems, SetFarmCoverageOpenItems] = useState([]);

    const getScheduleTypeKeyValue = (typeCode, typelistValues) => {
        const item = typelistValues.find((typeListItem) => {
            return typeListItem.code === typeCode;
        });
        return item ? item.displayKey : '';
    };

    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(fobCoverageOpenItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                SetFobCoverageOpenItems(openedItem);
            } else {
                SetFobCoverageOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [fobCoverageOpenItems]
    );

    const toggleShowHideFarmCoverage = useCallback(
        (item) => {
            const openedItem = _.clone(farmCoverageOpenItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                SetFarmCoverageOpenItems(openedItem);
            } else {
                SetFarmCoverageOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [farmCoverageOpenItems]
    );

    const getScheduleItemValue = (propertyInfo, scheduleItem, typelistValues) => {
        let value = '';
        switch (propertyInfo.valueType) {
            case 'DATE':
                value = scheduleItem.itemData[propertyInfo.id].dateValue ? intl.formatDate(new Date(scheduleItem.itemData[propertyInfo.id].dateValue), { year: 'numeric', month: 'short', day: 'numeric' }) : '-';
                break;
            case 'INTEGER':
                value = scheduleItem.itemData[propertyInfo.id].integerValue;
                break;
            case 'STRING':
                value = scheduleItem.itemData[propertyInfo.id].stringValue;
                break;
            case 'BOOLEAN':
                if(scheduleItem.itemData[propertyInfo.id])  {
                    value = `${translator( 
                        scheduleItem.itemData[propertyInfo.id].booleanValue ? messages.infoYes : messages.infoNo
                    )}`;
                }else {
                    value = ''
                }
                break;
            case 'TYPEKEY':
                value = getScheduleTypeKeyValue(scheduleItem.itemData[propertyInfo.id].typeCodeValue, typelistValues);
                break;

            default:
                break;
        }
        return value;

    };

    const getAvailableTypelistForSscheduledItems = (columnNameTypeList, propertyInfos) => {
        propertyInfos.forEach((propertyInfo) => {
            columnNameTypeList = propertyInfo.valueType === 'TYPEKEY' ? columnNameTypeList.concat(propertyInfo.availableTypeListValues) : columnNameTypeList;
        });
        return columnNameTypeList;
    };

    const getscheduleLineItem = (propertyInfos, scheduleItem, availableTypeList) => {
        const scheduleLineItem = {};
        propertyInfos.forEach((propertyInfo) => {
            const colName = propertyInfo.label;
            scheduleLineItem[colName] = getScheduleItemValue(propertyInfo, scheduleItem, availableTypeList);
        });
        return scheduleLineItem;
    };

    const getAdditionalCoveragesData = (additionalCoverages) => {
        return additionalCoverages.filter((addlCoverage) => {
            return addlCoverage.selected;
        });
    };

    const getLocationCoveragesData = (coverages) => {
        if (coverages) {
            return coverages.filter((coverage) => {
                return (coverage.name === 'Semen, Embryo and Tank')
                    || (coverage.categoryCodeIdentifier !== 'BP7_ProduceCovCat_EY'
                    && coverage.categoryCodeIdentifier !== 'BP7_LivestockCovCat_EY'
                    && coverage.categoryCodeIdentifier !== 'BP7_BusinessInterruptionCovCat_EY');
            });
        }

        return [];
    };

    const getLocationOutBuildings = (outBuildings) => {
        return outBuildings.filter((obj) => {
            return obj.additionalCoverages[0].selected;
        })
            .map((outBuilding) => {
                return {
                    name: outBuilding.outBuildingName,
                    deductible: outBuilding.additionalCoverages[0].terms[1].chosenTermValue,
                    limit: outBuilding.additionalCoverages[0].terms[0].chosenTermValue,
                    premium: outBuilding.additionalCoverages[0].amount
                };
            });
    };

    const getFarmLOBData = () => {
        const farmLOBData = _.cloneDeep(farmData);
        if (farmLOBData.locations) {
            farmLOBData.locations.forEach((location) => {
                let availableTypeList = [];
                const filteredSchedules = _.filter(
                    location.schedules, (schedule) => {
                        return schedule.scheduleItems.length > 0;
                    }
                );
                filteredSchedules.forEach((fschedule) => {
                    const scheduleLineItems = [];
                    availableTypeList = getAvailableTypelistForSscheduledItems(availableTypeList, fschedule.propertyInfos);
                    fschedule.scheduleItems.forEach((scheduleItem) => {
                        const scheduleLineItem = getscheduleLineItem(fschedule.propertyInfos, scheduleItem, availableTypeList);
                        scheduleLineItems.push(scheduleLineItem);
                    });
                    fschedule.scheduleLineItems = scheduleLineItems;
                });
                location.filteredSchedules = filteredSchedules;
                location.addlCoverages = getAdditionalCoveragesData(location.additionalCoverages);
                location.outBuildingCoverages = getLocationOutBuildings(location.farmOutbuildings);
                location.filteredCoverages = getLocationCoveragesData(location.coverages)
            });
        }
        return farmLOBData;
    };

    const farmLOBData = getFarmLOBData();

    if (_.isEmpty(farmLOBData)) {
        return null;
    }

    const readValue = useCallback(
        (id, path) => {
            if (path === 'locations') {
                return farmLOBData.locations;
            }
            return _.get(farmLOBData, path);
        },
        [farmLOBData]
    );

    const checkEmpty = (location) => {
        return _.isEmpty(location.filteredSchedules)
            && _.isEmpty(location.addlCoverages)
            && _.isEmpty(location.filteredSchedules);
    };

    const generateScheduleDataOverrides = useCallback((filteredSchedules) => {
        const overrides = filteredSchedules.map((filteredSchedule, index) => {
            return {
                [`ScheduleItemsHeader${index}`]: {
                    content: filteredSchedule.displayName
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, []);

    const generateFarmOutBuildingDataOverride = useCallback((farmOutbuildings) => {

        const overrides = farmOutbuildings.map( (farmOutbuilding, index) => {
            return {
                [`FarmOutBuildingCoverageDetailsHeader${index}`]: {
                    content :farmOutbuilding.outBuildingName
                },
                [`foShowContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`foContentDetailToggle${index}`]: {
                    icon: _.includes(fobCoverageOpenItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(fobCoverageOpenItems, index)
                        ? translator(messages.hideOutBuildingCoverages)
                        : translator(messages.showOutBuildingCoverages)
                },
                [`foCoverageContainer${index}`]: {
                    visible: _.includes(fobCoverageOpenItems, index),
                    show: fobCoverageOpenItems
                },
                [`fobPackageDetailsContainer${index}`]: {
                    header: getFarmOutBuildingHeaderSection(farmOutbuilding.outBuildingName)
                },
                [`farmBuildingAccordionEmptyMsg${index}`] :{
                    visible : farmOutbuilding.additionalCoverages === undefined

                }

            }

        });
        return Object.assign({}, ...overrides);
       }, [fobCoverageOpenItems]);

    const getDiscountsAndSurcharges = (discounts, surcharges) => {
        let discountSurcharges = [];
        discountSurcharges = discounts && !_.isEmpty(discounts) ? discounts.filter((value) => {
            return !(value.category.includes('Surcharge') || value.category.includes('surcharge')
                || value.category.includes('Exposure'));
        }).map((c) => {
            c.name = c.name || c.category;
            return c;
        }) : [];
        discountSurcharges = surcharges && !_.isEmpty(surcharges) ? discountSurcharges.concat(surcharges) : discountSurcharges;
        return _.sortBy(discountSurcharges, 'category');
    };


    const generateAccordionHeaderOverrides = useCallback(() => {
        if (farmLOBData.locations === undefined) {
            return Object.assign({});
        }
        const overrides = farmLOBData.locations.map((location, index) => {
            const count = index + 1;
            //TODO: Update the premium while complete the FRAM rate book
            const headName = `Farm Package # ${count} : ${location.farmPackageDetails.farmProgramType}`;
            const title = 'Location : '+ location.displayName;
            const ftfdVisible = ['1'];
            const ssVisible = ['1','2'];
            const fireProtectionGrade = location.farmPackageDetails.fireProtectionGrade_EY;
            const discountsAndSurcharges = getDiscountsAndSurcharges(location.discounts, location.surcharges)

            return {
                [`farmPackageDetailsContainer${index}`]: {
                    header: getHeaderSection(title,headName)
                },
                [`FarmOutBuildingCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.farmOutbuildings) && !_.isEmpty(location.farmOutbuildings[0].additionalCoverages)
                },
                [`AdditionalCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.addlCoverages)
                },
                [`ScheduleItemsCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.filteredSchedules)
                },
                [`accordionEmptyMsg${index}`]: {
                    visible: checkEmpty(location)
                },
                [`hasFullTimeFireDepartmentColumn${index}`]: {
                    visible : ftfdVisible.includes(fireProtectionGrade)
                },
                [`hasSuperiorShuttleColumn${index}`]: {
                    visible : ssVisible.includes(fireProtectionGrade)
                },
                [`farmShowContentToggleLink${index}`]: {
                    onClick: () => toggleShowHideFarmCoverage(index)
                },
                [`farmContentDetailToggle${index}`]: {
                    icon: _.includes(farmCoverageOpenItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(farmCoverageOpenItems, index)
                        ? translator(messages.hideFarmCoverages)
                        : translator(messages.showFarmCoverages)
                },
                [`farmCoverageContainer${index}`]: {
                    visible: _.includes(farmCoverageOpenItems, index),
                    show: farmCoverageOpenItems
                },
                [`policyFarmDiscounts${index}`]:{
                    data: discountsAndSurcharges,
                    value: discountsAndSurcharges,
                    visible: !_.isEmpty(discountsAndSurcharges)
                },
                [`additionalInterestsTableGrid${index}`] : {
                    data: location.additionalInterests,
                    visible: location.additionalInterests.length > 0
                },
                [`additionalInterestsContainer${index}`] : {
                    visible: location.additionalInterests.length > 0
                },
                ...generateScheduleDataOverrides(location.filteredSchedules),
                ...generateFarmOutBuildingDataOverride(location.farmOutbuildings),
            };
        });
        return Object.assign({}, ...overrides);
    }, [farmLOBData, generateScheduleDataOverrides,farmCoverageOpenItems]);

    function getCell(items, index, property) {
        if('name' === property.id) {
            return items.policyAdditionalInterest.displayName;
        }
        return items[property.id];
    };


    const overrides = {
        farmPolicyCoverageId: {
            visible: farmLOBData.farmerPolicyCoverages !== undefined,
            value: farmLOBData.farmerPolicyCoverages
        },
        ...generateAccordionHeaderOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            getCell: getCell,
        },
        resolveComponentMap: {
            coveragescomponent: CoveragesComponent,
            scheduleItemsComponent: ScheduleItemsComponent,
            farmPolicyCoverageComponent: PolicyCoverageComponent,
            discountscomponent: EYDiscountSurchargeTable
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={farmLOBData}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
PolicyFarmInformationComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};
export default PolicyFarmInformationComponent;
